import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Vendor } from 'src/app/models';
import { VendorsService } from 'src/app/services/vendors.service';

@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styles: [],
})
export class VendorsComponent implements OnInit {
  public filterValue$: Observable<string>;
  public gridData$: Observable<GridDataResult>;
  public loaded$: Observable<boolean>;
  public pageSize = 40;
  public rowHeight = 30;
  public skip$ = new BehaviorSubject<number>(0);
  public sort$ = new BehaviorSubject<SortDescriptor[]>([
    {
      field: 'partNumber',
      dir: 'asc',
    },
  ]);
  constructor(private vendorsService: VendorsService, public dialog: MatDialog) {}

  ngOnInit() {
    this.loaded$ = this.vendorsService.loaded$;
    this.filterValue$ = this.vendorsService.filter$;

    this.gridData$ = combineLatest(this.vendorsService.filteredEntities$, this.sort$, this.skip$).pipe(
      map(([vendors, [sort], skip]) => {
        const data = sort.dir === 'asc' ? _.sortBy(vendors, sort.field) : _.sortBy(vendors, sort.field).reverse();

        const pagedData = data.slice(skip, skip + this.pageSize);
        return { data: pagedData, total: data.length };
      }),
    );
  }

  openNewDialog() {
    this.vendorsService.openNewDialog().subscribe();
  }
  openEditDialog(vendor: Vendor) {
    this.vendorsService.openEditDialog(vendor).subscribe();
  }

  delete(vendor: Vendor) {
    this.vendorsService.delete(vendor);
  }
  filterVendors(filter) {
    this.vendorsService.setFilter(filter);
  }
  public sortChange(sort: SortDescriptor[]) {
    this.sort$.next(sort);
  }

  public pageChange(event: PageChangeEvent) {
    this.skip$.next(event.skip);
  }
}
